module.exports = __webpack_public_path__ + "img/ico-filter-schedule.8671d126.svg";